import { render, staticRenderFns } from "./ThankYouTaiwan.vue?vue&type=template&id=1e3e4c63&scoped=true&"
var script = {}
import style0 from "./ThankYouTaiwan.vue?vue&type=style&index=0&id=1e3e4c63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3e4c63",
  null
  
)

export default component.exports